import React, { useState } from 'react';

import classNames from 'classnames';

import { faqBlocks } from '../content/faqContent';

export const FaqContent: React.FC = () => {
  const [openedBlock, setOpenedBlock] = useState<string | null>(null);

  const toggleBlock = (title: string) => {
    setOpenedBlock((current) => (current === title ? null : title));
  };

  return (
    <div className="instruction__faq">
      {faqBlocks.map((block) => {
        const isOpen = openedBlock === block.title;

        return (
          <div
            key={block.title}
            className={classNames('instruction__faq-block', {
              'instruction__faq-block-open': isOpen,
            })}
          >
            <button type="button" className="instruction__faq-trigger" onClick={() => toggleBlock(block.title)}>
              <span>{block.title}</span>
              <span className="instruction__faq-icon">{isOpen ? '−' : '+'}</span>
            </button>

            {isOpen && (
              <div className="instruction__faq-content">
                {block.items.map((item) => (
                  <div key={item.question} className="instruction__faq-item">
                    <div className="instruction__faq-question">{item.question}</div>
                    {item.answers.map((answer) => (
                      <p key={answer} className="instruction__paragraph">
                        {answer}
                      </p>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
